import React, { useState, useEffect } from "react";

import { Globals } from "root/DataFunctions/BaseDataFns";
import { getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import { getPostDetails } from "root/DataFunctions/PostDataFns";
import SpinnerDiv from "root/Components/SpinnerDiv";
import "../styles/childPostDetail.scss";
import "../styles/childPostDetailNew.scss";
import {getUserImageUrl} from "root/DataFunctions/CommonDataFns";
import {UserTypeName} from "root/DataFunctions/Constants";
import {ImagePath} from "root/DataFunctions/Constants";

const ChildPostDetailNew = ({totalPost, index, filteredPost, nextPost, prevPost, setIndex, postStatus}) => {
    const [data, setData] = useState({ isLoading: true, data: [] });
    const [display, setDisplay] = useState({ name: "", value: ""});

    const arrowUrl = Globals.BaseURL + "/images/icons/child/arrow-left.svg";
    const senderAvatarImageUrl = Globals.APIFolder + '/user/' + filteredPost.sender_user_id + '/avatar?thumb&size=100'
    const videoUrl = Globals.BaseURL + "/images/icons/child/youtube.png";
    const docUrl = Globals.BaseURL + "/images/icons/child/document.png";
    //const externalLinkUrl = Globals.BaseURL + "/images/icons/child/external-link.png";
    const closeIcon = Globals.BaseURL + "/images/icons/child/close.png";
    const calendar = Globals.BaseURL + "/images/icons/child/calendar.png";

    const isFromMe = filteredPost.unenc_recipient_user_id === filteredPost.unenc_sender_user_id ? true : false;

    const getDocUrl = (  ) =>
    {
        let url = '/getFile.php?enc_docid=' + filteredPost.document_array[0];

        return url;
    }
    
    const PostDetailDisplay = ({post}) => {
        let displayImageUrl = '';

        if(display.value === undefined || display.value === ""){
            if(filteredPost.document_array[0] === undefined || filteredPost.document_array[0] === ''){
                displayImageUrl = ImagePath.IMAGE_NO_IMAGE;
            }
            else{
                displayImageUrl = ImagePath.IMAGE_POST_DOC;
            }
        }
        else{
            displayImageUrl = '/api/v1.0/images/'  + display.value;
        }


        if (display.name === "link") {
            return (
                <div className="image_wrap_link">
                     <iframe 
                         src={post.link} 
                         frameBorder="0" 
                         allowFullScreen
                     >
                     </iframe>
                </div>
            )
        } else if (display.name === "img") {
            return (
                <>
                    {data.isLoading ? 
                        <SpinnerDiv /> 
                        : 
                        <img className="pic" src={displayImageUrl} alt="" />
                    } 
                </>
            )
        } else {
            return (
                <>
                    <img className="pic" src={displayImageUrl} alt="" />
                </>
            )
        }
    }

    const Attachment = ({post}) => {
        if (post.link) {
            return (
                <a href={post.link} target="_blank" rel="noreferrer noopener">
                    <div className="article-external">
                        <img className="article-external-video" src={videoUrl} alt="video" />
                        {/*<p className="article-external-text">{post.link}</p>
                        <div className="child_button_icon">
                            <img className="article-external-img" src={externalLinkUrl} alt="external link" />
                        </div>*/}
                    </div>
                </a>
            )
        }else if (post.post_doc_id) {
            return (
                <a href={getDocUrl()} target="_blank" rel="noreferrer noopener">
                    <div className="article-external article-external_link">
                        <img className="article-external-doc"  src={docUrl} alt="document" />
                        {/*<div className="child_button_icon">
                            <img 
                                className="article-external-img" 
                                src={externalLinkUrl} 
                                alt="external link" 
                            />
                        </div>*/}
                    </div>
                </a>
            )
        } else {
            return "";
        }
    }

    const LinkThumbnail = ({ url }) => {
        return (
            <div 
                onClick={() => setDisplay({ name: "link", value: url })} 
                className={(display.name === "link") ?
                    "image_wrap_thumbnail image_wrap_thumbnail-link image_wrap_thumbnail-active"
                    :
                    "image_wrap_thumbnail image_wrap_thumbnail-link"
                    }
            >
                <iframe src={data.data.link} frameBorder="0"></iframe>
                <div className="image_wrap_thumbnail_placeholder"></div>
                <div className="image_wrap_thumbnail_overlay"></div>
            </div>
        )
    }

    const Thumbnail = ({ id }) => {
        const thumbnailUrl = '/api/v1.0/images/'  + id;

        return (
            <div 
                onClick={() => setDisplay({ name: "img", value: id })} 
                className={(display.name === "img" && id === display.value) ?
                    "image_wrap_thumbnail image_wrap_thumbnail-active"
                    :
                    "image_wrap_thumbnail"
                    }
            >
                <img src={thumbnailUrl} alt="thumbnail" />
            </div>
        )
    }

    // Used only to get all post images, should be used to populate other fields
    useEffect(() => {
        getPostDetails(filteredPost.post_id, (response) =>
        {
            const data = getDataFromResponse(response)[0];
            setData({ isLoading: false, data });

            if (data.link) {
                setDisplay({ name: "link", value: data.link })
            } else if (data.document_id) {
                setDisplay({ name: "img", value: data.image_array[0] })
            } else {
                setDisplay({ name: "img", value: data.image_array[0] })
            }
        });
    }, [filteredPost]);

    //Sender image/avatar
    const getPostUserImageUrl = (  ) =>
    {
        let url = '';

        if(filteredPost.posted_by_name === 'Me'){
            url = Globals.APIFolder + '/user/' + filteredPost.sender_user_id + '/avatar?thumb&size=100';
        }
        else{
            const urserImage = filteredPost.typeName === UserTypeName.BIRTH_PARENT ? null : filteredPost.user_image;
            url = getUserImageUrl(urserImage, 50,true);
        }

        return url;
    }

    return (
        <div className="child_post_detail">
            <div className="child_post_detail_container">
                {filteredPost.post_doc_id !== null && <div className="child_post_detail_doc ">
                    {/*<a href={getDocUrl()} target="_blank">
                        <img className="child_post_detail_doc_icon" src={docUrl} alt="document" />
                    </a>*/}
                </div>}

                <div className="child_post_detail_image_controls">
                    <div className="child_post_detail_inner">
                        <div onClick={ () => setIndex(null) } className="close_modal">
                            <button className="close_button">
                                <img className="icon" src={closeIcon} alt="Close Icon" />
                            </button>
                        </div>

                        <p onClick={prevPost} className="child_post_detail_image_control child_post_detail_image_control-left">
                            <img className="pic" src={arrowUrl} alt="Left arrow" />
                        </p>
                        
                        <div className="image_wrap">
                            <span className="image_wrap_loading"><SpinnerDiv /></span>
                            <PostDetailDisplay post={filteredPost} />
                            <div className="image_wrap_thumbnails">
                                {data.isLoading && <SpinnerDiv />}
                                {data.data.link && <LinkThumbnail url={display.value} />}
                                {data.data.image_array && data.data.image_array.length > 1 && data.data.image_array.map(id => 
                                        <Thumbnail key={id} id={id} />
                                    )
                                }
                            </div>
                        </div>

                        <p onClick={nextPost} className="child_post_detail_image_control child_post_detail_image_control-right">
                            <img className="pic" src={arrowUrl} alt="Right arrow" />
                        </p>
                    </div>
                    
                    <div className="child_post_detail_count">
                        <p className="text">
                            <span className="current">{index + 1}</span> / {totalPost} Post(s)
                        </p>
                    </div>
                </div>
                <div 
                    className={(filteredPost.post_doc_id || filteredPost.link) ?
                        "child_post_detail_prop child_post_detail_prop-external"
                        :
                        "child_post_detail_prop"
                        }
                >
                    <div className="child_post_detail_prop_title">
                        <h1 className="text">{filteredPost.title}</h1>
                    </div>

                    <div className="child_post_detail_prop_title">
                        <h4 className="text">{filteredPost.event_date}</h4>
                    </div>

                    <div>
                        <div className="child_post_detail_prop_text">{filteredPost.text}</div>
                    </div>

                    <Attachment post={filteredPost} />

                    <div className="child-post-info-meta">
                        <div className="meta-inner">
                            <p className="author">
                                {isFromMe && <img className="icn" src={senderAvatarImageUrl} alt="author_icon" />}
                                {!isFromMe && <img className="icn" src={getPostUserImageUrl()} alt="author_icon" />}
                                {isFromMe && ' ME' }
                                {!isFromMe && filteredPost.posted_by_name }
                            </p>
                            
                            <p className="date">
                                <img src={calendar} alt="calender_icon" />
                                {postStatus === "incomming" && filteredPost.date_updated}
                                {postStatus !== "incomming" && filteredPost.posted_date}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div onClick={ () => setIndex(null) } className="child_post_detail_back-drop">
            </div>
        </div>
    )
}

export default ChildPostDetailNew;